import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { inject } from '@angular/core';
import { AuthService } from '../auth.service';


export const AuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const authService = inject(AuthService);

        let token;
        if (authService.checkTokenExpiry()) {
            token = authService.currentAuthToken;

            let newReq = req.clone({
                setHeaders: {
                    "Authorization": `bearer ${token}`
                }
            });
            return next(newReq);
        }


    return next(req);
};